import type { AuditTrail } from '@openx/types/auditTrail.ts';
import { useCallback, useMemo, useState } from 'react';

const SHOW_REVERT_BUTTON_FOR_FIRST_N_CHANGES = 3;
const LAST_SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000;
const API_SCRIPT_USER_NAME = 'OpenX API ETL Process';

export const useHistoryEntryRevert = ({ trails }: { trails: AuditTrail[] }) => {
  const [selectedTrailId, setSelectedTrailId] = useState<string | null>(null);
  const [isRevertDrawerOpen, setRevertDrawerOpen] = useState(false);

  const handleOpenRevertDrawer = useCallback((traceId: string) => {
    setSelectedTrailId(traceId);
    setRevertDrawerOpen(true);
  }, []);

  const handleCloseRevertDrawer = useCallback(() => {
    setSelectedTrailId(null);
    setRevertDrawerOpen(false);
  }, []);

  const selectedAuditTrail = useMemo(() => {
    return selectedTrailId ? trails.find(trail => trail.trace_id === selectedTrailId) : undefined;
  }, [selectedTrailId, trails]);

  const shouldShowRevertButton = useCallback((index: number, entryDate: string, entryUser?: string): boolean => {
    if (
      index < SHOW_REVERT_BUTTON_FOR_FIRST_N_CHANGES &&
      entryUser &&
      entryUser !== API_SCRIPT_USER_NAME &&
      new Date(entryDate) > new Date(Date.now() - LAST_SEVEN_DAYS_IN_MS)
    ) {
      return true;
    }

    return false;
  }, []);

  return {
    shouldShowRevertButton,
    isRevertDrawerOpen,
    selectedAuditTrail,
    handleOpenRevertDrawer,
    handleCloseRevertDrawer,
  };
};
